<template>
  <div class="wrap">

    <div class="tab-content-wrapper">
      <div class="tab-content-inner">
        <div class="tab-content box">

          <UpgradeToProModal  v-if="!userIsPro"></UpgradeToProModal>
          <div v-if="userIsPro" class="faces">
            <div  @click="goToProfile(user)" class="face" v-for="user in profileWhoMarkedMeFavorite">
              <div class="img" :style="{'background': `url(${user.photo_small}) no-repeat center / cover`}"></div>
              <div class="details">
                <div class="name">
                  <p class="headline">{{ user.headline }}</p>
                  <p class="handle">@{{ user.handle }}</p>
                </div>
                <div class="details-star">
                  <i class="green-star"></i>
                </div>
              </div>
            </div>
          </div>

          <infinite-loading
              v-if="userIsPro"
              ref="infiniteLoadingWhoMarkedMeFavoriteUsers"
              @infinite="getWhoMarkedMeFavoriteUsers"
              spinner="bubbles">
              <span slot="no-results">
                  {{ "Users not exists" }}
              </span>
              <span slot="no-more">
                {{ "No more users" }}
              </span>
          </infinite-loading>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex';
import UpgradeToProModal from "../../../../buddy/views/widgets/UpgradeToProModal.vue";

export default {
  name: "WhoMarkedMeFavoriteUsersForm",
  components: {UpgradeToProModal},
  mixins: [require('@general/lib/mixin').default],
  data() {
    return {
      profileWhoMarkedMeFavorite: [],
      page: 0,
      limit: 20,
    }
  },
  computed: {
    ...mapState({
      userIsPro: 'userIsPro',
    }),
  },
  methods: {
    async getWhoMarkedMeFavoriteUsers(infiniteScroll) {
      let ret_users = [];
      await  axios.get(`/api/user/whomarkedmefavorite?page=${this.page}&limit=${this.limit}`)
          .then((users) => {
            this.profileWhoMarkedMeFavorite.push(...users.data);
            ret_users = users.data;
          })

      if (ret_users.length) {
        infiniteScroll.loaded()
      }

      if (ret_users.length < this.limit) {
        infiniteScroll.complete()
      }

      this.page++;
    },
    reset() {
      this.page = 1;
      this.profileWhoMarkedMeFavorite = [];
      if(this.$refs.infiniteLoadingWhoMarkedMeFavoriteUsers){
        this.$refs.infiniteLoadingWhoMarkedMeFavoriteUsers.stateChanger.reset();
      }
    },
    goToProfile(user) {
      this.goTo('/user/' + user.id)
    },
  },
  activated() {
    this.reset();
  },
  mounted() {
    app.$on('show-who-marked-me-favorite', this.reset);
  }
}
</script>

<style scoped>

</style>